import { connectCustom } from "@client/lib/misc";
import { TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type ContainerProps } from "../container";
import withStyleSheets from "../withStyleSheets";
import { makeStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const styleSelector = makeStyleSelector(TargetSelector.Entity);

  return (state: AppState, props: ContainerProps): ContainerProps => {
    return {
      ...props,
      style: styleSelector(state, props)
    };
  };
};
const TextContainer = connectCustom(makeMapStateToProps)(Component);
export default TextContainer;

export const TextContainerStyleSheetAll = withStyleSheets(TextContainer, ["h1", "h2", "h3", "h4", "h5", "h6", "text"]);
